export interface ArticleMeta {
  slug: string;
  title: string;
  excerpt: string;
  icon: string;
  seq: string;
  image: string;
  date: string;
  readTime: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'what-is-vigorbuy-spreadsheet',
    title: 'What Is VigorBuy Spreadsheet? A Complete Introduction',
    excerpt: 'Learn exactly what VigorBuy Spreadsheet offers, who it helps, and how it transforms the way businesses manage data, track inventory, and streamline operations.',
    icon: 'ri-question-mark',
    seq: 'art-01',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20interface%2C%20warm%20wooden%20desk%2C%20potted%20plant%2C%20coffee%20mug%2C%20soft%20golden%20morning%20light%20through%20window%2C%20cream%20and%20warm%20neutral%20color%20palette%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-01&orientation=landscape',
    date: 'July 18, 2026',
    readTime: '8 min read',
  },
  {
    slug: 'vigorbuy-vs-excel',
    title: 'VigorBuy Spreadsheet vs Excel: Which One Should You Choose?',
    excerpt: 'A detailed head-to-head comparison covering templates, ease of use, business workflows, collaboration, and which tool wins for different use cases.',
    icon: 'ri-scales-3-line',
    seq: 'art-02',
    image: 'https://readdy.ai/api/search-image?query=Modern%20desk%20with%20two%20laptops%20side%20by%20side%20showing%20different%20software%20interfaces%2C%20warm%20neutral%20tones%2C%20clean%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20professional%20comparison%20atmosphere%2C%20editorial%20productivity%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    date: 'July 19, 2026',
    readTime: '10 min read',
  },
  {
    slug: 'financial-spreadsheet-templates',
    title: 'Best Financial Spreadsheet Templates for 2026',
    excerpt: 'Discover top-rated financial spreadsheet templates for budgeting, expense tracking, cash flow analysis, and financial planning that save hours every week.',
    icon: 'ri-line-chart-line',
    seq: 'art-03',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20financial%20documents%20on%20white%20desk%20with%20calculator%2C%20pen%2C%20gold%20accents%2C%20clean%20accounting%20workspace%2C%20warm%20beige%20and%20cream%20tones%2C%20minimalist%20aesthetic%2C%20soft%20natural%20lighting%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-03&orientation=landscape',
    date: 'July 20, 2026',
    readTime: '9 min read',
  },
  {
    slug: 'inventory-management-guide',
    title: 'Inventory Management Spreadsheet: The Ultimate Guide',
    excerpt: 'Master inventory tracking with professional spreadsheet solutions. Learn stock monitoring, reorder automation, and warehouse optimization strategies.',
    icon: 'ri-archive-line',
    seq: 'art-04',
    image: 'https://readdy.ai/api/search-image?query=Modern%20warehouse%20shelf%20with%20neatly%20organized%20product%20boxes%2C%20barcode%20scanner%2C%20clipboard%20on%20table%2C%20warm%20industrial%20lighting%2C%20clean%20organized%20atmosphere%2C%20beige%20and%20cream%20tones%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-04&orientation=landscape',
    date: 'July 21, 2026',
    readTime: '11 min read',
  },
  {
    slug: 'sales-tracking-guide',
    title: 'Sales Tracking Spreadsheet: Complete 2026 Guide',
    excerpt: 'Build powerful sales dashboards, track leads, measure conversion rates, and generate performance reports with professional sales spreadsheet systems.',
    icon: 'ri-bar-chart-grouped-line',
    seq: 'art-05',
    image: 'https://readdy.ai/api/search-image?query=Modern%20sales%20workspace%20with%20laptop%20showing%20dashboard%20charts%2C%20notebook%20with%20sales%20notes%2C%20pen%2C%20warm%20cozy%20office%20lighting%2C%20cream%20and%20beige%20palette%2C%20minimalist%20clean%20design%2C%20editorial%20productivity%20photography&width=800&height=450&seq=article-05&orientation=landscape',
    date: 'July 22, 2026',
    readTime: '10 min read',
  },
  {
    slug: 'small-business-solutions',
    title: 'Small Business Spreadsheet Solutions That Actually Work',
    excerpt: 'From budgets to payroll to client management — discover the specific spreadsheet tools that help small businesses operate efficiently and profitably.',
    icon: 'ri-store-2-line',
    seq: 'art-06',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20modern%20small%20business%20office%20with%20laptop%2C%20invoices%20and%20receipts%20on%20desk%2C%20small%20potted%20succulent%2C%20warm%20natural%20lighting%2C%20cream%20and%20beige%20tones%2C%20minimalist%20aesthetic%2C%20professional%20editorial%20photography&width=800&height=450&seq=article-06&orientation=landscape',
    date: 'July 22, 2026',
    readTime: '8 min read',
  },
  {
    slug: 'spreadsheet-security-guide',
    title: 'Spreadsheet Security Best Practices for 2026',
    excerpt: 'Protect sensitive business data with proven spreadsheet security strategies, access control methods, backup protocols, and compliance guidelines.',
    icon: 'ri-shield-check-line',
    seq: 'art-07',
    image: 'https://readdy.ai/api/search-image?query=Modern%20secure%20office%20workspace%20with%20laptop%2C%20lock%20icon%20displayed%20on%20screen%2C%20coffee%20cup%2C%20notepad%2C%20warm%20professional%20lighting%2C%20cream%20and%20neutral%20palette%2C%20clean%20minimalist%20design%2C%20editorial%20photography&width=800&height=450&seq=article-07&orientation=landscape',
    date: 'July 23, 2026',
    readTime: '9 min read',
  },
  {
    slug: 'ecommerce-spreadsheet-tools',
    title: 'E-commerce Spreadsheet Tools Every Store Owner Needs',
    excerpt: 'From product listings to profit analysis — explore essential spreadsheet tools built specifically for online retailers and marketplace sellers.',
    icon: 'ri-shopping-cart-2-line',
    seq: 'art-08',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20e-commerce%20product%20display%20flat%20lay%20on%20white%20desk%2C%20fashion%20items%2C%20packaging%20boxes%2C%20laptop%20with%20online%20store%2C%20warm%20natural%20light%2C%20cream%20and%20beige%20tones%2C%20minimalist%20aesthetic%2C%20professional%20editorial%20product%20photography&width=800&height=450&seq=article-08&orientation=landscape',
    date: 'July 23, 2026',
    readTime: '10 min read',
  },
  {
    slug: 'project-management-tips',
    title: 'Project Management Spreadsheet Tips for Efficient Teams',
    excerpt: 'Learn how top-performing teams use spreadsheet-based project management systems to coordinate tasks, manage timelines, and deliver results on time.',
    icon: 'ri-task-line',
    seq: 'art-09',
    image: 'https://readdy.ai/api/search-image?query=Modern%20team%20meeting%20table%20with%20sticky%20notes%2C%20laptop%20showing%20project%20timeline%2C%20coffee%20cups%2C%20warm%20collaborative%20atmosphere%2C%20cream%20and%20beige%20palette%2C%20soft%20natural%20lighting%2C%20minimalist%20clean%20design%2C%20editorial%20photography&width=800&height=450&seq=article-09&orientation=landscape',
    date: 'July 23, 2026',
    readTime: '11 min read',
  },
];